/**
 * Month ranges as KPI tooltips say them ("Oct 2025 – Sep 2026"), so a figure on the Category Profile and on the Spend
 * Landscape can be compared on the months it covers.
 */

const monthOf = (iso: string, locale: string) =>
    new Date(Number(iso.slice(0, 4)), Number(iso.slice(5, 7)) - 1, 1).toLocaleDateString(locale, {month: 'short', year: 'numeric'});

/** The month before `iso` (YYYY-MM-DD), as YYYY-MM-01. */
function previousMonth(iso: string): string {
    const year = Number(iso.slice(0, 4));
    const month = Number(iso.slice(5, 7));
    return month === 1 ? `${year - 1}-12-01` : `${year}-${String(month - 1).padStart(2, '0')}-01`;
}

/** A range whose `to` is the last day or month included (a date filter: 2025-11-01 to 2026-10-31). */
export function monthRange(from: string, to: string, locale: string): string {
    const a = monthOf(from, locale);
    const b = monthOf(to, locale);
    return a === b ? a : `${a} – ${b}`;
}

/** A reporting period whose `end` is the first month after it (the Category Profile API: 2025-10-01 to 2026-10-01). */
export function periodRange(start: string, end: string, locale: string): string {
    return monthRange(start, previousMonth(end), locale);
}
